<template>
  <div class="container">
    <div :style="{width: barWidth}" />
  </div>
</template>

<script>
export default {
  name: 'ProgressBar',
  props: {
    value: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    }
  },
  computed: {
    barWidth () {
      return `${(this.$props.value / this.$props.max) * 100}%`;
    }
  }
};
</script>

<style scoped lang="scss">
  @import "../../style/color_";

  .container {
    height: 20px;
    background-color: $color-dark-gray;
    border-radius: 5px;
    padding: 2px;
  }

  .container > div {
    height: 100%;
    background-color: $color-primary;
    overflow: hidden;
    transition: all 700ms ease;
  }
</style>
